module.exports = __webpack_public_path__ + "static/elektro-1c606d634b58f4ce819e6146a25d189b.png";